/**
 * UN8 Matching module
 *
 * Core: engine.ts · valuesScore.ts · eligibility.ts · weights.ts
 * Pool: poolStore.ts (persistent approved profiles)
 * Interests: interestStore.ts (persistent likes + mutual matches + chat)
 * Session: matchStore.ts + weeklyStore.ts (self, weekly four, pass-replace)
 * UI: MatchApp.tsx (#/match weekly home · Selection / Messages / Profile)
 */

export * from "./engine";
export type {
  Gender,
  MatchProfile,
  MatchScales,
  MatchRecord,
  MatchState,
  MatchingPoolEntry,
  ProfileSource,
} from "./types";
export { oppositeGender, scalesFromAnswers } from "./types";
export {
  resolveViewerGender,
  genderFromOnboarding,
  genderFromOnboardingDraft,
  genderFromGuestUserId,
  silentDemoGender,
  isBinaryGender,
} from "./resolveGender";
export {
  matchStore,
  profileFromAnswers,
  guestSelf,
  getActivePool,
  getCandidatePool,
} from "./matchStore";
export {
  matchingPoolStore,
  applyReviewDecisionToPool,
} from "./poolStore";
export type { UpsertPoolResult } from "./poolStore";
export {
  readLocalVerificationStatus,
  effectiveReviewStatus,
  isReviewApprovedForDeck,
  isModerationBlocking,
  isGuestUserId,
} from "./approvalGate";
export { interestStore } from "./interestStore";
export type { Interest, MutualMatch, ChatMessage } from "./interestTypes";
export { DEMO_PROFILES } from "./demoPool";
export {
  isEligibleForMatching,
  getIneligibilityReasons,
  matchProfileFromApplication,
} from "./eligibility";

/* ── UN8: two-stage model (gates, then weighted affinity) ── */
export { evaluateGates, evaluateCountryGate, GATE_LABELS } from "./gates";
export type { GateCode, GateResult } from "./gates";
export {
  affinityScore,
  AFFINITY_WEIGHTS,
  AFFINITY_AXES,
  AFFINITY_LABELS,
} from "./affinity";
export type { AffinityAxis, AffinityBreakdown } from "./affinity";
export { explainMatch, ancestryPreferenceLine, EXPLAIN_AXIS_MIN } from "./explainMatch";
export { profileAnswerOverlap } from "./profileOverlap";
export type { ProfileOverlap, OverlapLine } from "./profileOverlap";
export {
  tierOf,
  packIntensity,
  chromePlanFromBilling,
} from "./chromePlan";
export type { ProfileTier, MatchChromePlan } from "./chromePlan";
export { FAITH_BANDS, faithBand, ANCESTRY_MODE, FAITH_SCOPE } from "./un8.config";
export type { FaithBand } from "./un8.config";
export { newMessageWeekStore, NEW_MESSAGES_PER_WEEK } from "./newMessageWeekStore";
